import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchBranding } from '../redux/modules/entities/branding/actions';
import store from '../redux/store';
import { authenticatedAndBrandingReady, getSdkLoaded, userIsAuthed } from '../redux/modules/userData/selectors';
import { isInIframe } from 'serenova-js-utils/browser';
import styled from 'styled-components';
import { cxInit } from '../utils/cxSdk';
import { LoadingSpinnerSVG } from 'cx-ui-components';
import { isBrandingUpdating } from '../redux/modules/entities/branding/selectors';
import { getSelectedEntityId } from '../redux/modules/entities/selectors';
import { isFormDirty, areSubEntityFormsDirty } from '../redux/modules/form/selectors';
import { setSdkLoaded } from '../redux/modules/userData';
import { isTokenExpired } from '../containers/Login/layout';
import { unsetSelectedEntityId } from '../redux/modules/entities';

const Loading = styled(LoadingSpinnerSVG)`
  position: absolute;
  top: calc(50% - ${props => props.size / 2}px);
  left: calc(50% - ${props => props.size / 2}px);
`;

export default function PrivateRoute(WrappedComponent) {
  let loaded = false;
class WrappedRoute extends Component {

    constructor(props) {
      super(props);
      this.state = {
        onLogin: true,
        redirectToLogin: false,
        sdkInitialized: false
      };
    }

    setLocalStateAndTenant() {
      if (!localStorage.getItem("token")) {
        this.setState({redirectToLogin: true});
        return;
      }
      const token = localStorage.getItem("token");
      const tenantId = localStorage.getItem("tenant");
      const userId = localStorage.getItem("userId");
      CxEngage.session.setToken(token);
      CxEngage.session.setUserIdentity(userId);
      CxEngage.session.setActiveTenant({ tenantId: tenantId, noSession: true }, function () {
        console.log('[SDK Listener] SDK tenant set to:', CxEngage.session.getActiveTenantId());
        loaded = true;
        store.dispatch(setSdkLoaded(true));
      });
    }

    isFreshLoad() {
      if (typeof CxEngage !== 'undefined' && Object.keys(CxEngage).length === 1) {
        this.setState({onLogin: false});
        return true;
      }
      //if user hits login url then redirected to the /configuration/users....
      if (localStorage.getItem("token") !== null) {
        this.setState({onLogin: false});
        this.setLocalStateAndTenant();
      }
      return false;
    }

    /** Check if url contains id that means to persist the sidepanel state to remain open..**/
    checkIfUrlContainsId() {
      return window.location.href.includes('?id=');
    }

    handleLoadEvent = () => {
      // constantly check if sdk has finished initialization
      window.addEventListener('message', this.handleMessageEvent);
    };

    handleMessageEvent = () => {
      if (CxEngage.version && !this.state.sdkInitialized) {
        this.setState({sdkInitialized : true});
      }
    };

    componentWillMount() {
      if (!isInIframe()) {
        if (this.props.isBrandingUpdating) {
          store.dispatch({
            type: 'FETCH_DATA',
            entityName: 'branding',
            entityId: this.props.selectedEntityId,
            currentEntityName: 'tenants',
            fetchingDependencies: true
          });
        } else {
          store.dispatch(fetchBranding());
        }
      } else {
        if (!this.checkIfUrlContainsId()) {
          store.dispatch(unsetSelectedEntityId());
        }
        store.dispatch(setSdkLoaded(false));
        if (this.isFreshLoad()) {
          cxInit();
          // validate if page has loaded completely
          addEventListener('load', this.handleLoadEvent);
        }
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (!isInIframe()) {
        if (this.props.isBrandingUpdating && prevProps.isBrandingUpdating !== this.props.isBrandingUpdating) {
          store.dispatch({
            type: 'FETCH_DATA',
            entityName: 'branding',
            entityId: this.props.selectedEntityId,
            currentEntityName: 'tenants',
            fetchingDependencies: true
          });
        }
        if (
          this.props.isFormDirty !== prevProps.isFormDirty ||
          this.props.areSubEntityFormsDirty !== prevProps.areSubEntityFormsDirty
        ) {
          store.dispatch({
            type: 'SET_IS_CURRENT_FORM_DIRTY_IN_CONFIG1',
            isDirty: this.props.isFormDirty || this.props.areSubEntityFormsDirty
          });
        }
      }
    }
    render() {
      if (!isInIframe()) {
        return this.props.hasStarted ? (
          <WrappedComponent {...this.props} entityName={this.props.match.params.entityName} />
        ) : (
          <Loading size={120} />
        );
      } else {
        if (this.state && this.state.redirectToLogin || isTokenExpired()) {
          return <Redirect to="/" />;
        }

        if (this.state && this.state.sdkInitialized) {
          this.setLocalStateAndTenant();
        }

        return this.props.hasStarted && this.state && this.state.onLogin || loaded ? (
          <WrappedComponent {...this.props} entityName={this.props.match.params.entityName} />
        ) : (
            <Loading size={120} />
        );
      }
    }
  }

  const mapStateToProps = state => ({
    hasStarted: authenticatedAndBrandingReady(state),
    userIsAuthed: userIsAuthed(state),
    selectedEntityId: getSelectedEntityId(state),
    isBrandingUpdating: isBrandingUpdating(state),
    isFormDirty: isFormDirty(state),
    areSubEntityFormsDirty: areSubEntityFormsDirty(state),
    sdkLoaded: getSdkLoaded(state)
  });

  WrappedRoute.propTypes = {
    hasStarted: PropTypes.bool.isRequired,
    userIsAuthed: PropTypes.bool.isRequired,
    match: PropTypes.object,
    entityName: PropTypes.string,
    selectedEntityId: PropTypes.string,
    isBrandingUpdating: PropTypes.bool,
    isFormDirty: PropTypes.bool,
    areSubEntityFormsDirty: PropTypes.bool,
    sdkLoaded: PropTypes.bool,
  };

  return connect(mapStateToProps)(WrappedRoute);
}
